app.controller("pricingController", [
    "$scope",
    "$location",
    "$timeout",
    "$uibModal",
    function ($scope, $location, $timeout, $uibModal) {
        $scope.controllerName = "pricingController";

        /**
         * Follows a #section on the URL, so a link can land on this page already scrolled to the
         * part it is about - #/pricing#transcription-pricing for the seat add-ons, which sit well
         * below the plan grid.
         *
         * Two things this has to work around, both of which stopped the plain
         * $viewContentLoaded handling that featuresController uses from being enough here:
         *
         *   - app.js scrolls the window back to the top on every $stateChangeSuccess, and does it
         *     with an 800ms jQuery animation when no hash is set. An animation still running from
         *     the previous page drags this one back up, so it is stopped first.
         *   - the sticky page header overlaps whatever is scrolled to the top of the viewport, so
         *     its height comes off the target.
         */
        function scrollToHashSection() {
            var sectionId = $location.hash();

            if (!sectionId) {
                return;
            }

            // Long enough for the plan cards and the background image to have settled, or the
            // measured offset is of a layout that no longer exists by the time we scroll.
            $timeout(function () {
                var element = document.getElementById(sectionId);

                if (!element) {
                    return;
                }

                var header = document.querySelector(".pricing-page .page-header");
                var headerHeight = header ? header.getBoundingClientRect().height : 0;
                var page = angular.element("html, body");

                if (angular.isFunction(page.stop)) {
                    page.stop(true, false);
                }

                window.scrollTo({
                    top: element.getBoundingClientRect().top + window.scrollY - headerHeight,
                    behavior: "smooth",
                });
            }, 150);
        }

        // Arriving with #section already on the URL.
        $scope.$on("$viewContentLoaded", scrollToHashSection);

        // The hash changing while this page is already open - a link followed from the page
        // itself, or the URL edited in place. ui-router treats a hash-only change as the same
        // state and does not re-render the view, so $viewContentLoaded never fires for it.
        $scope.$on("$locationChangeSuccess", scrollToHashSection);

        $scope.openDemoModal = function (planName) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/src/website/book-demo.modal.html',
                controller: 'bookDemoController',
                backdropClass: 'modern-modal-backdrop',
                windowClass: 'modern-modal-window',
                size: 'md',
                resolve: {
                    selectedPlan: function () {
                        return planName;
                    }
                }
            });

            modalInstance.result.then(function (result) {
                console.log('Modal closed with result:', result);
            }, function (reason) {
                console.log('Modal dismissed:', reason);
            });
        };

        /**
         * Buying transcription seats, rather than asking for a demo of them. A practice reaching
         * this button is already a CatTrax customer - the seats attach to a practice that exists -
         * so it signs in and buys on the spot.
         *
         * Buying and handing the seats out are two modals rather than one long one: a practice that
         * came for a second seat has nothing to assign yet, and one returning to move seats around
         * has nothing to buy. The app's payment settings dialog is never opened from here - it
         * carries the token wallet, top-ups and usage history, none of which belong in front of
         * someone who came to the pricing page for a seat.
         *
         * @param {string} tier - STANDARD or PREMIUM, the seat whose button was clicked.
         */
        $scope.openSeatPurchase = function (tier) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/src/website/seat-purchase.modal.html',
                controller: 'seatPurchaseController',
                backdropClass: 'modern-modal-backdrop',
                windowClass: 'modern-modal-window seat-purchase-window',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    selectedTier: function () {
                        return tier;
                    }
                }
            });

            modalInstance.result.then(function (result) {
                // The seats are paid for but nobody holds one yet, so the practice is taken
                // straight to the screen that hands them out.
                if (result && result.action === 'ASSIGN_SEATS') {
                    $scope.openSeatAssign();
                }
            }, function () {
                // Dismissed. Nothing was bought, and the page is unchanged.
            });
        };

        /**
         * Handing the practice's seats to its clinicians. Only reachable once the purchase modal
         * has signed someone in, which is what put a session and a practice in place.
         */
        $scope.openSeatAssign = function () {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/src/website/seat-assign.modal.html',
                controller: 'seatAssignController',
                backdropClass: 'modern-modal-backdrop',
                windowClass: 'modern-modal-window seat-assign-window',
                size: 'lg'
            });

            modalInstance.result.then(function (result) {
                // Ran out of seats part way through assigning them, so back to buying.
                if (result && result.action === 'BUY_SEATS') {
                    $scope.openSeatPurchase(null);
                }
            }, function () {
                // Dismissed. Whatever was assigned is already saved - seats apply on the click.
            });
        };
    }
]);
